<template>
    <div class="contact-us">
        <div class="header-empty"></div>
        <div class="app">
            <div class="main-content">
                <breadItem :title1="breadTitle1" :title2="breadTitle2" :link1="breadLink1" :link2="breadLink2"></breadItem>
                <div class="main-box clearfix color-blank fs14 mb40">
                    <div class="info-left fl pt20">
                        <div class="mb20" v-if="data.address"><img src="../../assets/images/area.png" alt="" class="mr20 wh20"><span>地址：{{data.address}}</span></div>
                        <div class="mb20" v-if="data.tel"><img src="../../assets/images/phone.png" alt="" class="mr20 wh20"><span>电话：{{data.tel}}</span></div>
                        <div class="mb20" v-if="data.code"><img src="../../assets/images/email.png" alt="" class="mr20 wh20"><span>邮编：{{data.code}}</span></div>
                        <div class="mb20" v-if="data.fax"><img src="../../assets/images/fax.png" alt="" class="mr20 wh20"><span>传真：{{data.fax}}</span></div>
                    </div> 
                    <div class="qr-box right-box fr tc">
                        <div class="fl mr20" v-if="data.wb_thumb">
                            <img :src="data.wb_thumb" alt="" class="wh80">
                            <div class="tc">官方微博</div>
                        </div>
                        <div class="fl" v-if="data.wx_thumb">
                            <img :src="data.wx_thumb" alt="" class="wh80">
                            <div class="tc">官方微信</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="map">
            <div class="main-content map-content">
                <div class="map" id="Map"></div>
            </div>
        </div>
        <div class="main-content">
            <nav-top></nav-top>
        </div>
    </div>
</template>
 
<script>
import navTop from '@/components/top'
import breadItem from '@/components/breadItem'
// import BMap from 'BMap'


import { baiduMap } from "@/utils/baiduMap.js";


export default {
    components: {
        navTop,
        breadItem
    },
    data() {
        return {
            data:'',
            center:{
             lng:'120.128665',
             lat:'30.281059'
            },
            zoom: 16,
            breadTitle1:'关于我们',
            breadTitle2:'联系我们',
            breadLink1:'/aboutUs/0.html',
            breadLink2:''
        };
    },
    created() {
        this.getData();
    },
    mounted() {
        
    },
    methods: {
        getMap:function(){
            var _this = this
            baiduMap('WM9Cx2m5ALmhZQ00iZSVgLFr').then(({BMap,BMapLib}) =>{
                 var map = new BMap.Map("Map");
                    var point = new BMap.Point(this.data.longitude,this.data.latitude);
                    map.centerAndZoom(point, 16);
                    map.enableScrollWheelZoom();
                    var content = '<div style="margin:0;line-height:20px;padding:2px;">' +
                                    '地址：'+this.data.address+'<br/>电话：'+this.data.tel+'<br/>简介：'+this.data.group_name+'' +
                                '</div>';
                    //创建检索信息窗口对象
                    var searchInfoWindow = null;
                    searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
                        title  : this.data.group_name,      //标题
                        width  : 300,             //宽度
                        height : 105,              //高度
                        panel  : "panel",         //检索结果面板
                        enableAutoPan : true,     //自动平移
                        searchTypes   :[
                            BMAPLIB_TAB_SEARCH,   //周边检索
                            BMAPLIB_TAB_TO_HERE,  //到这里去
                            BMAPLIB_TAB_FROM_HERE //从这里出发
                        ]
                    });
                    var marker = new BMap.Marker(point); //创建marker对象    
                    marker.addEventListener("click", function(e){
                        searchInfoWindow.open(marker);
                    });
                    searchInfoWindow.open(marker);
                    map.addOverlay(marker); //在地图中添加marker
            
             }).catch((err) => {
                console.log(err)
            })

          
            
        },
        getData:function(){
            this.$axios.post(this.api.about.contact,{},res =>{
                this.data=res.data;
                this.getMap();
            },err =>{
                this.data=''
            });
        },
        handler ({BMap, map}) {
            this.center.lng = 116.404
            this.center.lat = 39.915
            this.zoom = 15
        },
    },
    
};
</script>

<style scoped >
.anchorBL{display: none;}
.main-box{height:180px;line-height:20px;}
.main-box .right-box{line-height:20px;}
.main-box .qr-box .fl{padding-top:30px;width:160px;height:180px;box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);border-radius:5px;}
.main-box .qr-box p{margin-top:20px;}
.map-content{height:600px;}
.map{width:100%;height:600px;margin-bottom:40px;background:#F9F9F9;}
.bm-view {width: 100%;height: 600px;}
.contact-us{position: relative;}
.contact-us .go-top{
  right: -60px;
  bottom: -10px;
}
</style>



// WEBPACK FOOTER //
// src/view/aboutUs/contactUs.vue